import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const handlePrevious = () => {
        if (currentPage > 1) onPageChange(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) onPageChange(currentPage + 1);
    };

    if (totalPages <= 1) return null;

    return (
        <div className="flex justify-center items-center space-x-4 pb-10 py-2">
            <button
                disabled={currentPage === 1}
                onClick={handlePrevious}
                className={`px-4 py-3 rounded text-white ${currentPage === 1
                    ? "bg-primaryFadedColor cursor-not-allowed"
                    : "bg-primaryBtnColor hover:bg-primaryBtnHoverColor"
                    }`}
            >
                <FaAngleLeft />
            </button>

            <span className="text-sm font-medium text-gray-700">
                {currentPage} of {totalPages}
            </span>

            <button
                disabled={currentPage === totalPages}
                onClick={handleNext}
                className={`px-4 py-3 rounded text-white ${currentPage === totalPages
                    ? "bg-primaryFadedColor cursor-not-allowed"
                    : "bg-primaryBtnColor hover:bg-primaryBtnHoverColor"
                    }`}
            >
                <FaAngleRight />
            </button>
        </div>
    );
};

export default Pagination;
